<template>
  <w-icon-wrapper
    :width='23.995'
    :height='24.005'
    icon-name='113_Scan_Icon'
    view-box='0 0 23.995 24.005'
  >
    <g
      id="Gruppe_1"
      data-name="Gruppe 1"
    >
      <path
        id="Pfad_17"
        data-name="Pfad 17"
        d="M5.87,1v.01a.994.994,0,0,1-1,.99H2V4.88a1,1,0,0,1-1,1H.99a.988.988,0,0,1-.99-1V0H4.87a1,1,0,0,1,1,1"
        fill="currentColor"
      />
      <path
        id="Pfad_18"
        data-name="Pfad 18"
        d="M23,5.875h-.01a.994.994,0,0,1-.99-1V2.005h-2.88a1,1,0,0,1-1-1V1a.988.988,0,0,1,1-.99H24v4.87a1,1,0,0,1-1,1"
        fill="currentColor"
      />
      <path
        id="Pfad_19"
        data-name="Pfad 19"
        d="M5.87,23V23a.994.994,0,0,0-1-.99H2v-2.88a1,1,0,0,0-1-1H.99a.988.988,0,0,0-.99,1V24H4.87a1,1,0,0,0,1-1"
        fill="currentColor"
      />
      <path
        id="Pfad_20"
        data-name="Pfad 20"
        d="M23,18.13h-.01a.994.994,0,0,0-.99,1V22h-2.88a1,1,0,0,0-1,1v.01a.988.988,0,0,0,1,.99H24V19.13a1,1,0,0,0-1-1"
        fill="currentColor"
      />
      <path
        id="Pfad_21"
        data-name="Pfad 21"
        d="M23,9.39H19.5V3.13H4.5V9.39H.99a1,1,0,0,0,0,2H4.5v9.49h15V11.39H23a1,1,0,0,0,0-2M6.5,5.13h11V9.39H6.5Zm11,13.75H6.5V11.39h11Z"
        fill="currentColor"
      />
      <path
        id="Pfad_22"
        data-name="Pfad 22"
        d="M13.139,7.25a1,1,0,0,1-1,1h-3.5a1,1,0,0,1,0-2h3.5a1,1,0,0,1,1,1"
        fill="currentColor"
      />
      <path
        id="Pfad_23"
        data-name="Pfad 23"
        d="M16.019,13.63a1,1,0,0,1-1,1H8.639a1,1,0,0,1,0-2h6.38a1,1,0,0,1,1,1"
        fill="currentColor"
      />
      <path
        id="Pfad_24"
        data-name="Pfad 24"
        d="M15.014,17.755H8.639a1,1,0,1,1,0-2h6.375a1,1,0,1,1,0,2"
        fill="currentColor"
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconScan' };
</script>

